import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { bundleIcon, DataPie20Filled, DataPie20Regular } from '@fluentui/react-icons';
import { NavItem } from '@shared/components';
import { SignInContext } from '@modules/users';
import { REGISTRATIONS_NAV_VALUE, REGISTRATIONS_PATH } from '../constants';
import { isRegistrationsEnabled } from '../helpers/registrationAccess';

const DashboardIcon = bundleIcon(DataPie20Filled, DataPie20Regular);

type TProps = {
  className?: string;
};

// Entry point in the country registrations drawer.
const RegistrationsNavLink = ({ className }: TProps) => {
  const { organization } = useContext(SignInContext);
  if (!isRegistrationsEnabled(organization)) return null;

  return (
    <Link to={REGISTRATIONS_PATH} className={className}>
      <NavItem icon={<DashboardIcon />} value={REGISTRATIONS_NAV_VALUE}>
        Dashboard
      </NavItem>
    </Link>
  );
};

export default RegistrationsNavLink;
